interface SEOSchemaProps {
  type: 'WebPage' | 'Article' | 'FAQPage' | 'AboutPage';
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
  authorName?: string;
  articleBody?: string;
  faqs?: { question: string; answer: string }[];
  imageUrl?: string;
}

export default function SEOSchema({
  type,
  title,
  description,
  url,
  datePublished,
  dateModified,
  authorName,
  articleBody,
  faqs,
  imageUrl,
}: SEOSchemaProps) {
  const baseUrl = 'https://gayfilmnav.com';

  let schema: Record<string, unknown>;

  switch (type) {
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description,
        url: `${baseUrl}${url}`,
        datePublished,
        dateModified: dateModified || datePublished,
        author: authorName
          ? { '@type': 'Person', name: authorName }
          : { '@type': 'Organization', name: '精选gay片资源导航' },
        publisher: {
          '@type': 'Organization',
          name: '精选gay片资源导航',
          url: baseUrl,
        },
        image: imageUrl,
        articleBody: articleBody?.replace(/<[^>]*>/g, '').substring(0, 5000),
        inLanguage: 'zh-CN',
        isAccessibleForFree: true,
      };
      break;

    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (faqs || []).map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      };
      break;

    case 'AboutPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: title,
        description,
        url: `${baseUrl}${url}`,
        inLanguage: 'zh-CN',
        about: {
          '@type': 'Organization',
          name: '精选gay片资源导航',
          description: '专注于为成年用户提供gay片内容导航、观看指南与资源推荐的专业平台。',
          url: baseUrl,
        },
      };
      break;

    case 'WebPage':
    default:
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: title,
        description,
        url: `${baseUrl}${url}`,
        inLanguage: 'zh-CN',
        isPartOf: {
          '@type': 'WebSite',
          name: '精选gay片资源导航与观看指南',
          url: baseUrl,
        },
        about: {
          '@type': 'Thing',
          name: 'gay片资源导航',
          description: 'gay片在线观看、资源推荐、分类大全、观看指南',
        },
      };
      break;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}